/* eslint-disable react/jsx-no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Drawer,
  TextField,
  Select,
  MenuItem,
  Autocomplete,
  Chip,
  FormGroup,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { isValidNumber } from "../utils/validations";

interface CancellationFiltersProps {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  setStartDate: (date: Dayjs | null) => void;
  setEndDate: (date: Dayjs | null) => void;
  handleSubmit?: (clearData?: any) => void;
  users: any[];
  selectedUsers: string[];
  setSelectedUsers: (value: any) => void;
  memberShipType: string;
  setMemberShipType: (value: string) => void;
  bookingDateFrom: Dayjs | null;
  setBookingDateFrom: (value: Dayjs | null) => void;
  selectedCategory: string;
  setSelectedCategory: (value: string) => void;
  category: any[];
  internalData: any[];
  bookingStatus: string;
  setBookingStatus: (value: string) => void;
  employeeData: any[];
  selectedEmployee: string[];
  setSelectedEmployee: (value: string[]) => void;
  numberOfGuests: string;
  setNumberOfGuests: (value: string) => void;
  bookingNumberofDays: boolean;
  setBookingNumberofDays: (value: boolean) => void;
  isTodayBooking: boolean;
  setIsTodayBooking: (value: boolean) => void;
  noCategory?: boolean;
  noStatus?: boolean;
  handleClearFilters: () => void;
}

function CancellationFilters({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  handleSubmit,
  users,
  selectedUsers,
  setSelectedUsers,
  memberShipType,
  setMemberShipType,
  bookingDateFrom,
  setBookingDateFrom,
  selectedCategory,
  setSelectedCategory,
  category,
  internalData,
  bookingStatus,
  setBookingStatus,
  employeeData,
  selectedEmployee,
  setSelectedEmployee,
  numberOfGuests,
  setNumberOfGuests,
  bookingNumberofDays,
  setBookingNumberofDays,
  isTodayBooking,
  setIsTodayBooking,
  noCategory = false,
  noStatus = false,
  handleClearFilters,
}: CancellationFiltersProps) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [autoCompleteOpen, setAutoCompleteOpen] = useState(true);

  const [paidOption, setPaidOption] = useState("");
  const toggleDrawer = (open: boolean) => () => {
    setOpenDrawer(open);
  };

  const handleUserChange = (event: any, value: any[]) => {
    const selectedIds = value?.map((item) => item?.userId);
    setSelectedUsers(selectedIds);
  };

  const handleEmployeeChange = (event: any, value: any[]) => {
    const selectedIds = value?.map((item) => item?.id);
    setSelectedEmployee(selectedIds);
  };

  const handleClearAll = () => {
    setStartDate(null);
    setEndDate(null);
    setOpenDrawer(false);
    setSelectedUsers([]);
    handleSubmit?.(true);
    setBookingDateFrom(null);
    setMemberShipType("");
    setBookingStatus("");
    setSelectedCategory("");
    setSelectedEmployee([]);
    setNumberOfGuests("");
    setBookingNumberofDays(false);
    setIsTodayBooking(false);
    handleClearFilters();
  };

  return (
    <>
      <Button onClick={toggleDrawer(true)} className="btn btn_primary">
        <img src="/static/images/filter_icon.svg" alt="icon" /> Filters
      </Button>

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => {
          setOpenDrawer(false);
          handleClearAll();
        }}
        className="filter_drawer"
      >
        <div style={{ width: 420, padding: 20 }} className="filter_body">
          <div
            className="filter_head"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 20,
            }}
          >
            <h3>Filters</h3>
            <a onClick={handleClearAll} style={{ cursor: "pointer" }}>
              Clear All
            </a>
          </div>

          <div className="gap_m">
            <>
              <div className="w_100 control_group date_field">
                <label>Created Date</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    format="DD/MM/YYYY"
                    value={bookingDateFrom}
                    slotProps={{
                      textField: {
                        placeholder: "Start Date",
                        sx: {
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#9999", // change text & placeholder color
                            opacity: 1,
                          },
                        },
                      },
                    }}
                    onChange={(newValue) => setBookingDateFrom?.(newValue)}
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                      // textField: (params) => (
                      //   <TextField
                      //     {...params}
                      //     fullWidth
                      //     placeholder="Start Date"
                      //     hiddenLabel
                      //   />
                      // ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
              </div>

              <div className="w_50 control_group date_field">
                <label>Select Start Range</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    format="DD/MM/YYYY"
                    value={startDate}
                    slotProps={{
                      textField: {
                        placeholder: "Start Date",
                        sx: {
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#9999", // change text & placeholder color
                            opacity: 1,
                          },
                        },
                      },
                    }}
                    onChange={(newValue) => setStartDate?.(newValue)}
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                      // textField: (params) => (
                      //   <TextField
                      //     {...params}
                      //     fullWidth
                      //     placeholder="Start Date"
                      //     hiddenLabel
                      //   />
                      // ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
              </div>

              <div className="w_50 control_group date_field">
                <label>Select End Range</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    value={endDate}
                    onChange={(newValue) => setEndDate?.(newValue)}
                    minDate={dayjs(startDate)}
                    format="DD/MM/YYYY"
                    slotProps={{
                      textField: {
                        placeholder: "End Date",
                        sx: {
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#9999", // change text & placeholder color
                            opacity: 1,
                          },
                        },
                      },
                    }}
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                    disabled={!startDate}
                  />
                </LocalizationProvider>
              </div>

              <div className="control_group w_100">
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={users}
                  value={users?.filter((option) =>
                    selectedUsers?.includes(option?.userId)
                  )}
                  onChange={handleUserChange}
                  getOptionLabel={(option) => option?.userId}
                  isOptionEqualToValue={(option: any, value: any) =>
                    option?.userId === value?.userId
                  }
                  onOpen={() => setAutoCompleteOpen(true)}
                  onClose={() => setAutoCompleteOpen(false)}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                      const { key, ...tagProps } = getTagProps({ index });
                      return (
                        <Chip
                          key={key}
                          label={option?.name}
                          {...tagProps}
                          sx={{
                            "& .MuiChip-deleteIcon": {
                              color: "#BC8F4B", // your desired color
                              "&:hover": {
                                color: "#BC8F4B", // hover color (optional)
                              },
                            },
                          }}
                        />
                      );
                    })
                  }
                  renderOption={(props, option: any, { selected }) => {
                    const { key, ...rest } = props;
                    return (
                      <li key={key} {...rest}>
                        <FormControlLabel
                          control={<Checkbox checked={selected} />}
                          name="option"
                          label={option?.name}
                        />
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select Member" />
                  )}
                />
              </div>

              <div className="control_group w_100">
                <Select
                  name="page"
                  value={memberShipType}
                  onChange={(e) => setMemberShipType(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value={""} disabled>
                    Membership Type
                  </MenuItem>
                  <MenuItem value={"Solo"}>Solo</MenuItem>
                  <MenuItem value={"Duo"}>Duo</MenuItem>
                </Select>
              </div>

              {noCategory ? null : (
                <div className="control_group w_100">
                  <Select
                    name="page"
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value={""} disabled>
                      Category
                    </MenuItem>
                    {category?.map((item: any) => (
                      <MenuItem key={item?.id} value={item?.id}>
                        {item?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              )}

              {noStatus ? null : (
                <div className="control_group w_100">
                  <Select
                    name="page"
                    value={bookingStatus}
                    onChange={(e) => setBookingStatus(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value={""} disabled>
                      Booking Status
                    </MenuItem>
                    {internalData?.map((item: any) => (
                      <MenuItem key={item?.id} value={item?.name}>
                        {item?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              )}
              <div className="control_group w_100">
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={employeeData}
                  value={employeeData?.filter((option) =>
                    selectedEmployee?.includes(option?.id)
                  )}
                  onChange={handleEmployeeChange}
                  getOptionLabel={(option) => option?.name}
                  isOptionEqualToValue={(option: any, value: any) =>
                    option?.id === value?.id
                  }
                  onOpen={() => setAutoCompleteOpen(true)}
                  onClose={() => setAutoCompleteOpen(false)}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                      const { key, ...tagProps } = getTagProps({ index });
                      return (
                        <Chip
                          key={key}
                          label={option?.name}
                          {...tagProps}
                          sx={{
                            "& .MuiChip-deleteIcon": {
                              color: "#BC8F4B", // your desired color
                              "&:hover": {
                                color: "#BC8F4B", // hover color (optional)
                              },
                            },
                          }}
                        />
                      );
                    })
                  }
                  renderOption={(props, option: any, { selected }) => {
                    const { key, ...rest } = props;
                    return (
                      <li key={key} {...rest}>
                        <FormControlLabel
                          control={<Checkbox checked={selected} />}
                          name="option"
                          label={option?.name}
                        />
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select Employee" />
                  )}
                />
              </div>

              <div className="control_group w_100">
                <TextField
                  id="amount"
                  placeholder="Number Of Guests"
                  fullWidth
                  hiddenLabel
                  inputProps={{ maxLength: 10 }}
                  value={numberOfGuests}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (isValidNumber(value)) {
                      setNumberOfGuests(value);
                    }
                  }}
                />
              </div>

              <div className="control_group ">
                <FormGroup
                  className="paid_checkbox"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={bookingNumberofDays}
                        onChange={() =>
                          setBookingNumberofDays(!bookingNumberofDays)
                        }
                      />
                    }
                    label="Bookings (Last 30 Days)"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isTodayBooking}
                        onChange={() => setIsTodayBooking(!isTodayBooking)}
                      />
                    }
                    label="Today's Bookings"
                  />
                </FormGroup>
              </div>
            </>
          </div>

          <div className="btn_flex">
            <Button
              className="btn btn_primary"
              onClick={() => {
                if (handleSubmit) {
                  handleSubmit();
                }
                setOpenDrawer(false);
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default CancellationFilters;
